<template>
<div>
    <v-alert v-if="error" color="error" icon="mdi-alert-octagon-outline" outlined text>
        {{error}}
    </v-alert>

    <v-simple-table dense class="organization">
        <tbody>
        <tr>
            <th>Name</th>
            <td>{{organization.name}}</td>
        </tr>
        <tr>
            <th>Email</th>
            <td>{{organization.email}}</td>
        </tr>
        <tr>
            <th>Billing Address</th>
            <td>{{organization.address}}</td>
        </tr>
        <tr>
            <th>Payment Method</th>
            <td>
                <span class="text-capitalize">
                    {{organization.payment_method}}
                </span>
            </td>
        </tr>
        <tr>
            <th>Plan</th>
            <td>{{organization.plan}}</td>
        </tr>
        <tr>
            <th>Subscription Status</th>
            <td>
                <template v-if="status">
                    <v-chip label small outlined :color="status.color">{{status.name}}</v-chip>
                    <v-btn v-if="status.id === 'inactive'" small color="success" class="ml-1 action" @click="post('update')">
                        Add
                    </v-btn>
                    <v-btn v-if="status.id === 'canceled'" small color="success" class="ml-1 action" @click="post('reactivate')">
                        Reactivate
                    </v-btn>
                </template>
            </td>
        </tr>
        <tr>
            <th>Billing Date</th>
            <td>
                <span v-if="organization.current_period_end">
                    {{new Date(organization.current_period_end).toLocaleDateString()}}
                </span>
            </td>
        </tr>
        </tbody>
    </v-simple-table>

    <v-btn color="primary" :loading="loading" @click="post('update')" class="mt-3">Update Information</v-btn>
</div>
</template>

<script>
export default {
    props: {
        id: String,
    },

    data() {
        return {
            loading: false,
            error: '',
            organization: {},
        };
    },

    mounted() {
        this.get();
    },
    
    computed: {
        status() {
            const status = this.organization.subscription_status;
            if (!status) {
                return;
            }
            const statuses = {
                trialing: {name: 'Free Trial', color: 'success'},
                active: {name: 'Active', color: 'success'},
                inactive: {name: 'Payment Method Required', color: 'error'},
                past_due: {name: 'Payment Failed', color: 'error'},
                unpaid: {name: 'Payment Failed', color: 'error'},
                canceled: {name: 'Canceled', color: 'warning'},
            };
            const s = statuses[status];
            if (!s) {
                return {id: status, name: status, color: ''};
            }
            s.id = status;
            return s
        },
    },

    methods: {
        get() {
            this.loading = true;
            this.error = '';
            this.$api.organization(this.id, null,(data, meta) => {
                this.loading = false;
                if (meta.error) {
                    this.error = meta.error;
                    return;
                }
                this.organization = data || {};
            });
        },
        post(action) {
            this.loading = true;
            this.error = '';
            this.$api.organization(this.id,{action, url: window.location.href},(data, meta) => {
                if (meta.error) {
                    this.loading = false;
                    this.error = meta.error;
                    return;
                }
                this.$st.send('organization-'+action, null);
                if (data && data.redirect) {
                    window.location = data.redirect;
                    return;
                }
                this.loading = false;
                this.get();
            });
        },
    },
}
</script>

<style scoped>
.organization tr {
    background-color: unset !important;
}
.organization th {
    font-weight: normal;
    color: rgba(0,0,0,0.6);
    height: 36px !important;
    width: 200px;
    padding-left: 0 !important;
}
.organization td, .organization th {
    font-size: 1rem !important;
    border-bottom: none !important;
}
.action {
    height: 24px !important;
    font-size: smaller !important;
}
</style>